<template>
  <div class="flex min-h-screen bg-gray-100">
    <!-- 桌面端侧边栏 -->
    <div class="hidden md:block fixed top-0 left-0 h-full w-56 bg-gray-800 text-white shadow-lg z-50">
      <div class="p-4">
        <div class="mb-6">
          <img src="/images/icon.png" alt="logo" class="w-full h-auto py-2" />
        </div>
        <nav class="flex flex-col space-y-2">
          <router-link 
            to="/" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            主页
          </router-link>
          <router-link 
            to="/matches" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            赛程
          </router-link>
          <router-link 
            to="/league-table" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            积分榜
          </router-link>
          <router-link 
            to="/league-analysis" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            联赛分析
          </router-link>
          <router-link 
            to="/team-analysis" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            球队分析
          </router-link>
          <router-link 
            to="/player-analysis" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            球员分析
          </router-link>
          <router-link 
            to="/match-review" 
            class="px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-700 hover:text-white"
            active-class="font-bold bg-blue-500 text-white"
          >
            精彩赛事
          </router-link>
        </nav>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="flex-1 md:ml-56 pb-16 md:pb-0 p-6">
      <router-view v-slot="{ Component }">
        <component :is="Component" v-if="Component" />
        <div v-else class="container mx-auto px-4 py-8">
          <div class="bg-white rounded-lg shadow-lg p-6 mb-8">
            <h1 class="text-3xl font-bold text-gray-800 mb-4">欢迎来到FootViz足球数据分析平台</h1>
            <p class="text-gray-600 mb-6">
              FootViz是一个专业的足球数据分析平台，提供球队、球员、联赛等多维度的数据分析功能。
              帮助足球爱好者、教练、分析师和球队管理人员更好地理解比赛数据。
            </p>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div class="bg-blue-50 rounded-lg p-6 border border-blue-100">
                <h2 class="text-xl font-semibold text-blue-800 mb-2">球员分析</h2>
                <p class="text-gray-600 mb-4">深入分析球员表现数据，包括进球、助攻、传球成功率等关键指标。</p>
                <router-link 
                  to="/player-analysis" 
                  class="inline-block bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  查看详情
                </router-link>
              </div>
              
              <div class="bg-green-50 rounded-lg p-6 border border-green-100">
                <h2 class="text-xl font-semibold text-green-800 mb-2">球队分析</h2>
                <p class="text-gray-600 mb-4">全面了解球队战术表现，包括攻防数据、阵容分析等。</p>
                <router-link 
                  to="/team-analysis" 
                  class="inline-block bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  查看详情
                </router-link>
              </div>
              
              <div class="bg-purple-50 rounded-lg p-6 border border-purple-100">
                <h2 class="text-xl font-semibold text-purple-800 mb-2">联赛分析</h2>
                <p class="text-gray-600 mb-4">掌握联赛整体趋势，积分榜变化，球队对战分析等。</p>
                <router-link 
                  to="/league-analysis" 
                  class="inline-block bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  查看详情
                </router-link>
              </div>
            </div>
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="bg-white rounded-lg shadow-lg p-6">
              <h2 class="text-2xl font-bold text-gray-800 mb-4">最新赛事</h2>
              <p class="text-gray-600 mb-4">查看最新的足球赛事信息和比赛结果。</p>
              <router-link 
                to="/matches" 
                class="inline-block bg-gray-800 hover:bg-black text-white px-4 py-2 rounded-lg transition-colors"
              >
                浏览赛程
              </router-link>
            </div>
            
            <div class="bg-white rounded-lg shadow-lg p-6">
              <h2 class="text-2xl font-bold text-gray-800 mb-4">精彩回顾</h2>
              <p class="text-gray-600 mb-4">重温经典比赛，观看精彩进球和战术分析。</p>
              <router-link 
                to="/match-review" 
                class="inline-block bg-gray-800 hover:bg-black text-white px-4 py-2 rounded-lg transition-colors"
              >
                观看回顾
              </router-link>
            </div>
          </div>
        </div>
      </router-view>
    </div>
    
    <!-- 移动端底部导航 -->
    <MobileNav class="md:hidden" />
  </div>
</template>

<script setup>
import MobileNav from './components/MobileNav.vue'
</script>

<style>
/* 已通过Tailwind CSS处理样式 */
</style>